import * as actionTypes from '../actionTypes/hto';

export function getHTOConfig() {
    return { type: actionTypes.GET_HTO_CONFIG };
}

export function getLocationServiceDetails(lat, lng) {
    return { type: actionTypes.GET_LOCATION_SERVICE_DETAILS, lat, lng };
}

export function getSlots(pincode) {
    return { type: actionTypes.GET_SLOTS, pincode };
}

export function getHTOAppointmentCancelReasons() {
    return { type: actionTypes.GET_CANCEL_REASONS };
}

export function cancelHTOOrder(orderId, reason) {
    return { type: actionTypes.CANCEL_HTO_ORDER_LOAD, orderId, reason };
}

export function getAgentInfo(phone) {
    return { type: actionTypes.GET_AGENT_INFO, phone };
}

export function bookHTOAppointment(data) {
    return { type: actionTypes.BOOK_APPOINTMENT, data };
}

export function resetLocationServiceDetails(flag) {
    return { type: actionTypes.RESET_ERROR_LOCATION_SERVICE_DETAILS, flag };
}
